import Disclosure from './disclosure';

const DYNAMIC_VIEW_URL_CLASS = 'dynamic-view-url';

class PrivateAccessUrlComponent {
  updateLinks(encoded) {
    const links = document.getElementsByClassName(DYNAMIC_VIEW_URL_CLASS);

    for (let i = 0; i < links.length; i++) {
      let href = links[i].getAttribute('data-original-href') || links[i].getAttribute('href');
      href = href + '?' + encoded;
      links[i].setAttribute('href', href);
      links[i].setAttribute('rel', 'nofollow');
    }
  }

  init() {
    const location = window.location.href;

    if (location.includes('?private-access=')) {
      this.changeContent();
    }
  }

  changeContent() {
    const sections = document.getElementById('generatedContent');
    const formData = new FormData();
    formData.append('currentPath', window.drupalSettings.path.currentPath);

    jQuery.ajax({
      method: 'POST',
      data: formData,
      url: `${Disclosure.getCurrentLangUrlPrefix()}/private-access-content${window.location.search}`,
      processData: false,
      contentType: false,
      headers: {
        credentials: 'same-origin',
      },
      success: (response) => {
        if (response.content !== '') {
          sections.outerHTML = response.content;
        }
      },
    });
  }
}

export default PrivateAccessUrlComponent;
